import PropTypes from 'prop-types'
import classNames from 'classnames'

import classes from './FilterCheckbox.module.scss'

const FilterCheckbox = ({ id, label, isSelected, onClick }) => (
  <label htmlFor={id} className={classes.wrapper}>
    <input
      id={id}
      type='checkbox'
      className={classes.hiddenInput}
      checked={isSelected}
      onChange={onClick}
    />
    <span className={classNames(classes.checkbox, { [classes.checked]: isSelected })}>
      {isSelected && <i className='fa fa-check' aria-hidden='true' />}
    </span>
    <span className={classes.label}>{label}</span>
  </label>
)

FilterCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default FilterCheckbox
